import React, {useState} from 'react';
import {TableCell, CircularProgress, Modal, Box, Button, Typography} from "@material-ui/core";
import _ from "lodash";
import moment from "moment";
import {ListRenderer} from "../../components/ListRenderer/ListRenderer";
import {useNavigate} from "react-router-dom";
import ReactPlayer from "react-player";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import {signOut} from "aws-amplify/auth";
import "./EventList.css";


export const EventList = () => {
    const navigate = useNavigate();
    const [contentGroup, setContentGroup] = React.useState("ALL");
    const [toFilter, setToFilter] = React.useState(undefined);
    const [queryParams, setQueryParams] = React.useState(undefined)

    React.useEffect(() => {
        let tomorrow = moment().startOf('day').add(1, 'days');

        setToFilter(tomorrow.toDate());

        setQueryParams({
            limit: 25,
            ProjectionExpression: "Name, Start, Channel, Program, ContentGroup, Profile, Status, Description, SourceVideoUrl, Created, EdlLocation, HlsMasterManifest, Id, BootstrapTimeInMinutes, AudioTracks, DurationMinutes, GenerateOptoClips, GenerateOrigClips, Variables, TimecodeSource",
            toFilter: moment(tomorrow.toDate()).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z",
        })

    }, []);

    const handleDetailsView = (row) => {
        navigate("/viewEvent", {state: {
                back: {
                    name: "Events List",
                    link: "/listEvents"
                },
                data: row
            }
        });
    };

    const bucketName = "kong-dev-thumbnails";
    const region = process.env.REACT_APP_REGION;
    const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID;
    const userPoolId = process.env.REACT_APP_USER_POOL_ID
    const idToken = sessionStorage.getItem("idToken");
    const [openModal, setOpenModal] = useState(false);
    
    const s3Client = new S3Client({
        region,
        credentials: fromCognitoIdentityPool({
          clientConfig: { region },
          identityPoolId,
          logins: {
            [`cognito-idp.${region}.amazonaws.com/${userPoolId}`]: idToken,
          },
        }),
      });
      
    const getSignedUrlForImage = async (imageKey) => {
        try {
            const command = new GetObjectCommand({
            Bucket: bucketName,
            Key: imageKey,
            });
        
            const { Body } = await s3Client.send(command);
        
            const blob = await streamToBlob(Body);
            return URL.createObjectURL(blob);
        } catch (error) {
            console.error("Error fetching PNG from S3:", error);
            return null;
        }
    };
      
    const streamToBlob = async (stream) => {
        const chunks = [];
        for await (const chunk of stream) {
            chunks.push(chunk);
        }
        return new Blob(chunks, { type: "image/png" });
    };

    const getRowLive = (row) => {
        const isRTMP = /^rtmp:\/\//i.test(row.SourceVideoUrl);
        const [imageUrl, setImageUrl] = React.useState("");
        React.useEffect(() => {
            const fetchImage = async () => {
                if (!row.Variables?.home_team || !row.Variables?.away_team) return;
    
                const homeTeamFormatted = row.Variables.home_team.replace(/\s/g, '_');
                const awayTeamFormatted = row.Variables.away_team.replace(/\s/g, '_');
                const imageKey = `${awayTeamFormatted}_${homeTeamFormatted}.png`;
    
                try {
                    const url = await getSignedUrlForImage(imageKey);
                    setImageUrl(url);
                } catch (error) {
                    console.error("Error fetching image:", error);
                }
            };
    
            fetchImage();
        }, [row]);

        return [
            <TableCell align="left" className="custom-table-cell">
                <div className="custom-row" onClick={() => handleDetailsView(row)}>
                
                    {(row.SourceVideoUrl && !isRTMP ) ? <ReactPlayer
                                  url={row?.SourceVideoUrl}
                                  width="45%"
                                  height="280px"
                                  controls={true}
                                  playing={false}
                                  loop={true}
                                />:
                                <div className='thumbnail'>
                                    {imageUrl ?<img src={imageUrl} 
                                        alt={row.Variables?.away_team+" "+"vs"+" "+row.Variables?.home_team}
                                    />: <CircularProgress color="inherit" />} </div>
                                } 
                    <div className="details-container">
                        <p className="date-text">
                            {row.Start && moment(row.Start).format("MMMM DD - h:mm A")}
                        </p>
                        <p className="title-text">{row.Name}</p>
                    </div>
                </div>              
            </TableCell>
        ]
    }

    const getRowUpcoming = (row) => {
        const [imageUrl, setImageUrl] = React.useState("");
        React.useEffect(() => {
            const fetchImage = async () => {
                if (!row.Variables?.home_team || !row.Variables?.away_team) return;
    
                const homeTeamFormatted = row.Variables.home_team.replace(/\s/g, '_');
                const awayTeamFormatted = row.Variables.away_team.replace(/\s/g, '_');
                const imageKey = `${awayTeamFormatted}_${homeTeamFormatted}.png`;
    
                try {
                    const url = await getSignedUrlForImage(imageKey);
                    setImageUrl(url);
                } catch (error) {
                    console.error("Error fetching image:", error);
                }
            };
    
            fetchImage();
        }, [row]);

        return [
            <TableCell align="left" className="custom-table-cell">
                <div className="custom-row" onClick={() => handleDetailsView(row)}>
                    <div className="thumbnail">
                    {imageUrl ? (
                        <img
                        src={imageUrl}
                        alt={`${row.Variables?.away_team} vs ${row.Variables?.home_team}`}
                        />
                    ) : (
                        <CircularProgress color="inherit" />
                    )}
                    </div>

                    <div className="details-container">
                    <p className="date-text">
                        {row.Start && moment(row.Start).format("MMMM DD - h:mm A")}
                    </p>
                    <p className="title-text">{row.Name}</p>
                    </div>
                </div>
            </TableCell>
        ]
    }

    const getRowComplete = (row) => {
        const [imageUrl, setImageUrl] = React.useState("");
        React.useEffect(() => {
            const fetchImage = async () => {
                if (!row.Variables?.home_team || !row.Variables?.away_team) return;
    
                const homeTeamFormatted = row.Variables.home_team.replace(/\s/g, '_');
                const awayTeamFormatted = row.Variables.away_team.replace(/\s/g, '_');
                const imageKey = `${awayTeamFormatted}_${homeTeamFormatted}.png`;
    
                try {
                    const url = await getSignedUrlForImage(imageKey);
                    setImageUrl(url);
                } catch (error) {
                    console.error("Error fetching image:", error);
                }
            };
    
            fetchImage();
        }, [row]);

        return [
            <TableCell align="left" className="custom-table-cell">
                <div className="custom-row" onClick={() => handleDetailsView(row)}>
                    <div className="thumbnail">
                    {imageUrl ? (
                        <img
                        src={imageUrl}
                        alt={`${row.Variables?.away_team} vs ${row.Variables?.home_team}`}
                        />
                    ) : (
                        <CircularProgress color="inherit" />
                    )}
                    </div>

                    <div className="details-container">
                    <p className="date-text">
                        {row.Start && moment(row.Start).format("MMMM DD - h:mm A")}
                    </p>
                    <p className="title-text">{row.Name}</p>
                    </div>
                </div>
                </TableCell>
        ]
    }

    const handleContentGroupChange = (e) => {
        let contentGroupEvent = _.get(e, 'target.value');
        setContentGroup(contentGroupEvent);
        let queryParamsCopy = queryParams;

        if (contentGroupEvent === "ALL") {
            delete queryParamsCopy["ContentGroup"]
        }
        else {
            queryParamsCopy["ContentGroup"] = contentGroupEvent;
        }

        setQueryParams(queryParamsCopy);
    }

    const handleTimeChange = (filterName, dateTime) => {
        let queryParamsCopy = _.cloneDeep(queryParams);
        queryParamsCopy[filterName] = moment(dateTime).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
        setToFilter(queryParamsCopy[filterName])
        setQueryParams(queryParamsCopy);
    };

    const queryParamsQueued = { ...queryParams, Status: "Queued" };
    const queryParamsLive = {...queryParams, Status: "In Progress"};
    const queryParamsComplete = { ...queryParams, Status: "Complete"}

    return (
        <>
        <ListRenderer
            fetchPath={`event/all`}
            queryParams={queryParamsLive}
            backendPagination={true}
            getRow={getRowLive}
            header={{
                title: "Live",
                parentFilters: "events",
                filterHandlers: {
                    onContentGroupChange: handleContentGroupChange,
                    selectedContentGroup: contentGroup,
                    toFilter: toFilter,
                    onTimeFilterChange: handleTimeChange
                },
                hideRemoveFilters: true,
                parentFilters: false,
                contentGroupFilter: false
            }}
            tableHeaders={[]}
            emptyTableMessage={<>You don't have any Live events.</>}
            rows={{
                actions: false
            }}
        />
        <ListRenderer
            fetchPath={`event/all`}
            queryParams={queryParamsQueued}
            backendPagination={true}
            getRow={getRowUpcoming}
            header={{
                title: "Upcoming",
                parentFilters: "events",
                filterHandlers: {
                    onContentGroupChange: handleContentGroupChange,
                    selectedContentGroup: contentGroup,
                    toFilter: toFilter,
                    onTimeFilterChange: handleTimeChange
                },
                hideRemoveFilters: true,
                parentFilters: false,
            }}
            tableHeaders={[]}
            emptyTableMessage={<>You don't have any events schedules yet.</>}
            rows={{
                actions: false
            }}
        />
        <ListRenderer
            fetchPath={`event/all`}
            queryParams={queryParamsComplete}
            backendPagination={true}
            getRow={getRowComplete}
            header={{
                title: "Completed",
                parentFilters: "events",
                filterHandlers: {
                    onContentGroupChange: handleContentGroupChange,
                    selectedContentGroup: contentGroup,
                    toFilter: toFilter,
                    onTimeFilterChange: handleTimeChange
                },
                hideRemoveFilters: true,
                parentFilters: false,
            }}
            tableHeaders={[ ]}
            emptyTableMessage={<>You don't have any events schedules yet.</>}
            rows={{
                actions: false
            }}
        />
        <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="logout-modal-title"
            aria-describedby="logout-modal-description"
        >
            <Box 
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    textAlign: "center",
                }}
            >
                <Typography id="logout-modal-title" variant="h6" component="h2">
                    Oops! You have been logged out due to inactivity.
                </Typography>
                <Typography id="logout-modal-description" sx={{ mt: 2 }}>
                    Please login again to continue.
                </Typography>
                <Button 
                    variant="contained" 
                    color="primary" 
                    sx={{ mt: 3 }} 
                    onClick={async () => {
                            await signOut();
                            window.location.href = "/login";
                        }}
                >
                    OK
                </Button>
            </Box>
        </Modal>

        
        </>
        
    );
}